"use strict";
/**
 * This file was auto generated, please do not edit it directly.
 **/

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.IntegrationFieldMapping = void 0;

var IntegrationFieldMapping =
/** @class */
function () {
  function IntegrationFieldMapping(restClient) {
    this.restClient = restClient;
  } // Queries

  /**
   * @param string - integrationFieldMappingId
   * @return Promise|Observable|any
   */


  IntegrationFieldMapping.prototype.GetIntegrationFieldMapping = function (integrationFieldMappingId) {
    return this.restClient.get('IntegrationFieldMapping/UseCase/GetIntegrationFieldMapping', {
      integrationFieldMappingId: integrationFieldMappingId
    });
  };
  /**
   * @param string - salesforceEventSettingId
   * @param string? - fieldMappingType
   * @return Promise|Observable|any
   */


  IntegrationFieldMapping.prototype.ListFieldMappingsForSalesforceEventSetting = function (salesforceEventSettingId, fieldMappingType) {
    if (fieldMappingType === void 0) {
      fieldMappingType = null;
    }

    return this.restClient.get('IntegrationFieldMapping/UseCase/ListFieldMappingsForSalesforceEventSetting', {
      salesforceEventSettingId: salesforceEventSettingId,
      fieldMappingType: fieldMappingType
    });
  }; // Commands

  /**
   * @param string - fieldMappingType salesforce-import-lead|salesforce-import-contact|salesforce-export-lead|salesforce-export-contact|marketo-field-mapping
   * @param string - integrationSettingType
   * @param string - integrationSettingId
   * @param string - fieldType question|user-attribute|user-name|user-identifier
   * @param string - fieldId
   * @param string - integrationFieldValue
   * @param boolean - canUpdateEventFarmField true|false
   * @param boolean - canUpdateIntegrationField true|false
   * @param boolean - canDeleteMapping true|false
   * @param string? - updateRule never|different|blank
   * @param string? - fieldName
   * @return Promise|Observable|any
   */


  IntegrationFieldMapping.prototype.CreateIntegrationFieldMapping = function (fieldMappingType, integrationSettingType, integrationSettingId, fieldType, fieldId, integrationFieldValue, canUpdateEventFarmField, canUpdateIntegrationField, canDeleteMapping, updateRule, fieldName) {
    if (updateRule === void 0) {
      updateRule = null;
    }

    if (fieldName === void 0) {
      fieldName = null;
    }

    return this.restClient.post('IntegrationFieldMapping/UseCase/CreateIntegrationFieldMapping', {
      fieldMappingType: fieldMappingType,
      integrationSettingType: integrationSettingType,
      integrationSettingId: integrationSettingId,
      fieldType: fieldType,
      fieldId: fieldId,
      integrationFieldValue: integrationFieldValue,
      canUpdateEventFarmField: canUpdateEventFarmField,
      canUpdateIntegrationField: canUpdateIntegrationField,
      canDeleteMapping: canDeleteMapping,
      updateRule: updateRule,
      fieldName: fieldName
    });
  };
  /**
   * @param string - integrationFieldMappingId
   * @return Promise|Observable|any
   */


  IntegrationFieldMapping.prototype.DeleteIntegrationFieldMapping = function (integrationFieldMappingId) {
    return this.restClient.post('IntegrationFieldMapping/UseCase/DeleteIntegrationFieldMapping', {
      integrationFieldMappingId: integrationFieldMappingId
    });
  };
  /**
   * @param string - integrationFieldMappingId
   * @param string - fieldType question|user-attribute|user-name|user-identifier
   * @param string - fieldId
   * @param string? - fieldName
   * @return Promise|Observable|any
   */


  IntegrationFieldMapping.prototype.SetIntegrationFieldMappingFields = function (integrationFieldMappingId, fieldType, fieldId, fieldName) {
    if (fieldName === void 0) {
      fieldName = null;
    }

    return this.restClient.post('IntegrationFieldMapping/UseCase/SetIntegrationFieldMappingFields', {
      integrationFieldMappingId: integrationFieldMappingId,
      fieldType: fieldType,
      fieldId: fieldId,
      fieldName: fieldName
    });
  };
  /**
   * @param string - integrationFieldMappingId
   * @param string - integrationFieldName
   * @return Promise|Observable|any
   */


  IntegrationFieldMapping.prototype.SetIntegrationFieldMappingName = function (integrationFieldMappingId, integrationFieldName) {
    return this.restClient.post('IntegrationFieldMapping/UseCase/SetIntegrationFieldMappingName', {
      integrationFieldMappingId: integrationFieldMappingId,
      integrationFieldName: integrationFieldName
    });
  };
  /**
   * @param string - integrationFieldMappingId
   * @param string - updateRule never|different|blank
   * @return Promise|Observable|any
   */


  IntegrationFieldMapping.prototype.SetIntegrationFieldMappingUpdateRule = function (integrationFieldMappingId, updateRule) {
    return this.restClient.post('IntegrationFieldMapping/UseCase/SetIntegrationFieldMappingUpdateRule', {
      integrationFieldMappingId: integrationFieldMappingId,
      updateRule: updateRule
    });
  };

  return IntegrationFieldMapping;
}();

exports.IntegrationFieldMapping = IntegrationFieldMapping;